module.exports = __webpack_public_path__ + "static/far-cry_prize-8ad7dbb1130395cc9c98524e7d46bf5f.avif";